import { LogoType } from './types';
export const WIX_BRAND_LOGO_URLS = {
    [LogoType.wixClassic]: '82f27b_51c1e39598f94531ab9d830494fe17df~mv2.png',
    [LogoType.wixStudio]: '82f27b_af1457d5816a4550a50283a8c5601232~mv2.png',
};
export const WIX_BRAND_LOGO_STYLES = {
    [LogoType.wixClassic]: {
        backgroundColorEnabled: false,
        imageSize: 'small',
        textAlign: 'left',
        region: { paddingTop: '10px' },
    },
    [LogoType.wixStudio]: {
        backgroundColorEnabled: false,
        imageSize: 'small',
        textAlign: 'left',
        region: { paddingTop: '40px' },
    },
};
//# sourceMappingURL=wix-brand-logos.js.map